import { render, staticRenderFns } from "./SCardClientDebtsComp.vue?vue&type=template&id=70c4ef83&"
import script from "./SCardClientDebtsComp.vue?vue&type=script&lang=js&"
export * from "./SCardClientDebtsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports